const PROFILE_KEY = "ecliptica.birthProfile";
const PROFILE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function now() {
  return Date.now();
}

function isFresh(timestamp) {
  return Number.isFinite(timestamp) && now() - timestamp <= PROFILE_TTL_MS;
}

function parseStorage(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const storedAt = Number(parsed.storedAt || 0);
    if (!isFresh(storedAt)) return null;
    return {
      birthDate: String(parsed.birthDate || ""),
      birthTime: String(parsed.birthTime || ""),
      birthPlace: String(parsed.birthPlace || ""),
      storedAt,
    };
  } catch (_err) {
    return null;
  }
}

function safeGet(storage, key) {
  try {
    return storage.getItem(key);
  } catch (_err) {
    return null;
  }
}

function safeSet(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch (_err) {
    // ignore storage write failures
  }
}

export function readBirthProfile() {
  const sessionPayload = parseStorage(safeGet(sessionStorage, PROFILE_KEY));
  if (!sessionPayload) return {};
  return {
    birthDate: sessionPayload?.birthDate || "",
    birthTime: sessionPayload?.birthTime || "",
    birthPlace: sessionPayload?.birthPlace || "",
  };
}

export function writeBirthProfile({ birthDate, birthTime, birthPlace }) {
  const safeBirthDate = String(birthDate || "");
  const safeBirthTime = String(birthTime || "");
  const safeBirthPlace = String(birthPlace || "").slice(0, 200);
  const storedAt = now();

  const sessionPayload = JSON.stringify({
    birthDate: safeBirthDate,
    birthTime: safeBirthTime,
    birthPlace: safeBirthPlace,
    storedAt,
  });

  safeSet(sessionStorage, PROFILE_KEY, sessionPayload);
}
